import React from 'react';
import s from './index.scss';

const LiveIcon = ({ text = 'LIVE' , itemIconClass }) => (
  <div className={`${s.liveBlinker} ${s[itemIconClass]}`}>
    <i />
    {text}
  </div>
);

export default LiveIcon;
